import styled from 'styled-components';

export const StyledButtonLink = styled.a`
    display: block;
    width: 50%;
    padding: 15px 0;
    width: fit-content;
    text-align: center;
    text-decoration: none;
    outline: none;
    background-color: #00a0b6;
    color: #ffffff;
    border-radius: 10px;
    font-size: 16px;
    font-weight: 500;
    line-height: 20.4px;

    @media screen and (min-width: 577px) {
        width: 30%;
        width: fit-content;
        font-size: 20px;
        padding: 15px;
        line-height: 25.5px;
    }
`;
